import { Controller } from "@hotwired/stimulus"
import { TempFormHelper } from "~/helpers/temp_form_helper"

export default class extends Controller {
  static get values() {
    return {
      companyListId: { type: String, default: "" },
      exportLimit: Number,
      totalCount: Number,
      planName: String
    }
  }

  submit() {
    if (this.totalCountValue > this.exportLimitValue) {
      const successMessage = i18n.t("js.back.company_actions.export.export_limit", { limit: this.exportLimitValue, plan_name: this.planNameValue })
      App.displayFlash("success", successMessage)
    }

    TempFormHelper.create("/lead/companies/export", "post", (form) => {
      TempFormHelper.addHiddenInput(form, "company_list_id", this.companyListIdValue)
    }).submit() // requestSubmit does not trigger the download
  }
}
